import MenuItem from "@mui/material/MenuItem";
import React, { ReactNode, useState } from "react";
import { StyledMenu } from "../ui";
import { ExportDataIcon, TriangleIcon } from "../images";
import { CustomButton } from "../ui/CustomButton";
import { ExportDataModals } from "../../types/enums";
import {
  ExportAccountPlansFromCampaignModal,
  ExportAccountsCSVModal,
  ExportPlaybooksFromCampaignModal,
} from "../ui/modal";
import { useGetCampaignSummaryQuery } from "../../api";
import { useParams } from "react-router-dom";
import { ExportAccountsPlanPDFBtn } from "../ui/buttons";

export const ExportMenu = () => {
  const { campaign_id } = useParams();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [currentModal, setCurrentModal] = useState<ExportDataModals>(
    ExportDataModals.none,
  );

  const { data } = useGetCampaignSummaryQuery({
    campaign_id: campaign_id!,
  });

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setCurrentModal(ExportDataModals.none);
  };

  const openModalHandler = (modal: ExportDataModals) => {
    setCurrentModal(modal);
  };

  const options = [
    {
      label: ExportDataModals.csv,
      isDisabled: !data?.is_ever_analysed,
    },
    {
      label: ExportDataModals.account_plan,
      isDisabled: !data?.one_account_plan_complete,
    },
    {
      label: ExportDataModals.account_plan_links,
      isDisabled: !data?.one_account_plan_complete,
    },
    {
      label: ExportDataModals.playbook,
      isDisabled: !data?.has_playbooks,
    },
  ];

  const modals: Record<ExportDataModals, ReactNode> = {
    [ExportDataModals.account_plan]: (
      <ExportAccountsPlanPDFBtn
        campaign_id={campaign_id!}
        onClose={handleClose}
      />
    ),
    [ExportDataModals.csv]: <ExportAccountsCSVModal onClose={handleClose} />,
    [ExportDataModals.account_plan_links]: (
      <ExportAccountPlansFromCampaignModal onClose={handleClose} />
    ),
    [ExportDataModals.playbook]: (
      <ExportPlaybooksFromCampaignModal onClose={handleClose} />
    ),
    [ExportDataModals.none]: null,
  };

  if (!data?.is_ever_analysed && !data?.one_account_plan_complete) return null;

  return (
    <div>
      <CustomButton
        onClick={handleClick}
        variant="outlined"
        customColor="#FFFFFF"
        textColor="#1D3E70"
        type="button"
        sx={{
          borderColor: "#1D3E70",
          height: "42px",
        }}
      >
        <ExportDataIcon /> Export <TriangleIcon color={"#1D3E70"} />
      </CustomButton>

      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "white",
          },
        }}
      >
        {options.map(({ label, isDisabled }) => (
          <MenuItem
            key={label}
            sx={{ display: "flex", gap: "12px", alignItems: "center" }}
            onClick={() => openModalHandler(label)}
            disabled={isDisabled}
          >
            {label}
          </MenuItem>
        ))}
      </StyledMenu>
      {modals[currentModal]}
    </div>
  );
};
